/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Checkbox, Form, Input, Tooltip, BackTop, Spin } from 'antd';
import {
    ExclamationCircleOutlined,
    PlusCircleOutlined,
} from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBlocker } from '../../../util/usePrompt';
import { useNavigate, useParams } from 'react-router-dom';
import useNotify from '../../../context/Notification/useNotify';
import ModalDiscardChanges from '../../../components/Shared/modal/discardChanges';
import ModalConfirm from '../../../components/Shared/modal/confirm';
import RiskAssessmentService from '../../../services/RiskAssessment.service';
import { ROUTER } from '../../../constants/router';
import ModalDelete from '../../../components/Shared/modal/delete';

export default function Tab2({ detail, mode, getRiskAssessment, lastUpdate }) {
    const { t, i18n } = useTranslation();
    const { riskId } = useParams();
    const lang = i18n.language;
    const [form] = Form.useForm();
    const { TextArea } = Input;
    const [fields, setFields] = useState([]);
    const [checkExData, setCheckExData] = useState([]);
    const [riskMapMaster, setRiskMapMaster] = useState([]);
    const [definitionsMaster, setDefinitionsMaster] = useState([]);
    const [nameDelete, setNameDelete] = useState('');
    const [statusForm, setStatusForm] = useState(true);
    const [loadingForm, setLoadingForm] = useState(false);

    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);
    useBlocker((nextLocation) => onChangePage(nextLocation), change === true);
    const Navigate = useNavigate();
    const notify = useNotify();

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };
    const handelOk = async () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        setOpenChange(false);
        setChange(false);
        setIsChangeLocation(false);

        await form.resetFields();
        await Navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
        await getRiskMapEx();
        await getRiskAssessment();
    };
    const changePage = () => {
        Navigate(`${ROUTER.RISK_MANAGEMENT.RA}/${riskId}/view?tab=2`);
    };

    const getLevelColor = (id) => {
        switch (id) {
            case '4a63f6a407f611ed8bf4fa163e89e3c8':
                return { color: '#FFF', background: '#A7D17E' };
            case '5fead50b07f611ed8bf4fa163e89e3c8':
                return { color: '#FFF', background: '#FFD15C' };
            case '749e117407f611ed8bf4fa163e89e3c8':
                return { color: '#FFF', background: '#EA8A54' };
            case 'a64aa37007f611ed8bf4fa163e89e3c8':
                return { color: '#FFF', background: '#CD5D4A' };
            case 'b5c52f8307f611ed8bf4fa163e89e3c8':
                return { color: '#FFF', background: '#A3402F' };
            default:
                return { color: '#FFF', background: '' };
        }
    };

    // ConfirmDelete
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false);

    // Confirm
    const [openConfirm, setOpenConfirm] = useState(false);
    const [valueSave, setValueSave] = useState();
    const [loading, setLoading] = useState(false);

    const onSubmit = async () => {
        if (mode === 'create') {
            const riskMapTopic = [];
            for (const item in riskMapMaster) {
                // console.log(riskMapMaster[item])
                let riskLevel = [];
                if (valueSave.riskMap) {
                    if (
                        valueSave.riskMap.includes(
                            riskMapMaster[item].mRiskMapTopicId
                        )
                    ) {
                        // console.log(riskMapMaster[item].mRiskMapTopicId)
                        for (const i in riskMapMaster[item].riskMapLevels) {
                            riskLevel.push({
                                riskMapLevelId: null,
                                riskMapLevelName:
                                    valueSave[
                                        riskMapMaster[item].riskMapLevels[i]
                                            .mRiskMapLevelId
                                    ].riskMapLevelName,
                                mRiskMapLevelId:
                                    riskMapMaster[item].riskMapLevels[i]
                                        .mRiskMapLevelId,
                            });
                        }
                        riskMapTopic.push({
                            riskMapTopicId: null,
                            mRiskMapTopicId:
                                riskMapMaster[item].mRiskMapTopicId,
                            riskMapLevel: riskLevel,
                        });
                    }
                }
            }

            const riskMapTopicAddOn = [];
            if (valueSave.riskMapTopicAddOn) {
                // console.log(valueSave.riskMapTopicAddOn)
                for (const item in valueSave.riskMapTopicAddOn) {
                    let riskMapLevelAddOnName = [];
                    if (
                        valueSave.riskMapTopicAddOn[item].riskMapLevelAddOn1
                            .riskMapLevelAddOnName
                    ) {
                        riskMapLevelAddOnName.push({
                            riskMapLevelAddOnId:
                                valueSave.riskMapTopicAddOn[item]
                                    .riskMapLevelAddOn1.riskMapLevelAddOnId ||
                                null,
                            riskMapLevelAddOnName:
                                valueSave.riskMapTopicAddOn[item]
                                    .riskMapLevelAddOn1.riskMapLevelAddOnName,
                            seq: 1,
                        });
                    }
                    if (
                        valueSave.riskMapTopicAddOn[item].riskMapLevelAddOn2
                            .riskMapLevelAddOnName
                    ) {
                        riskMapLevelAddOnName.push({
                            riskMapLevelAddOnId:
                                valueSave.riskMapTopicAddOn[item]
                                    .riskMapLevelAddOn2.riskMapLevelAddOnId ||
                                null,
                            riskMapLevelAddOnName:
                                valueSave.riskMapTopicAddOn[item]
                                    .riskMapLevelAddOn2.riskMapLevelAddOnName,
                            seq: 2,
                        });
                    }
                    if (
                        valueSave.riskMapTopicAddOn[item].riskMapLevelAddOn3
                            .riskMapLevelAddOnName
                    ) {
                        riskMapLevelAddOnName.push({
                            riskMapLevelAddOnId:
                                valueSave.riskMapTopicAddOn[item]
                                    .riskMapLevelAddOn3.riskMapLevelAddOnId ||
                                null,
                            riskMapLevelAddOnName:
                                valueSave.riskMapTopicAddOn[item]
                                    .riskMapLevelAddOn3.riskMapLevelAddOnName,
                            seq: 3,
                        });
                    }
                    if (
                        valueSave.riskMapTopicAddOn[item].riskMapLevelAddOn4
                            .riskMapLevelAddOnName
                    ) {
                        riskMapLevelAddOnName.push({
                            riskMapLevelAddOnId:
                                valueSave.riskMapTopicAddOn[item]
                                    .riskMapLevelAddOn4.riskMapLevelAddOnId ||
                                null,
                            riskMapLevelAddOnName:
                                valueSave.riskMapTopicAddOn[item]
                                    .riskMapLevelAddOn4.riskMapLevelAddOnName,
                            seq: 4,
                        });
                    }
                    if (
                        valueSave.riskMapTopicAddOn[item].riskMapLevelAddOn5
                            .riskMapLevelAddOnName
                    ) {
                        riskMapLevelAddOnName.push({
                            riskMapLevelAddOnId:
                                valueSave.riskMapTopicAddOn[item]
                                    .riskMapLevelAddOn5.riskMapLevelAddOnId ||
                                null,
                            riskMapLevelAddOnName:
                                valueSave.riskMapTopicAddOn[item]
                                    .riskMapLevelAddOn5.riskMapLevelAddOnName,
                            seq: 5,
                        });
                    }
                    riskMapTopicAddOn.push({
                        riskMapTopicAddOnId: null,
                        riskMapTopicAddOnName:
                            valueSave.riskMapTopicAddOn[item]
                                .riskMapTopicAddOnName,
                        seq: Number(item) + 1,
                        riskMapLevelAddOn: riskMapLevelAddOnName,
                    });
                }
            }

            try {
                const { data } = await RiskAssessmentService.createRiskMap({
                    riskMapTopic: riskMapTopic ? riskMapTopic : [],
                    riskMapTopicAddOn: riskMapTopicAddOn
                        ? riskMapTopicAddOn
                        : [],
                });
                if (data?.resultCode === 1) {
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully save data'),
                    });
                    setOpenChange(false);
                    setChange(false);
                    setLoading(false);
                    setOpenConfirm(false);
                    Navigate(
                        `${ROUTER.RISK_MANAGEMENT.RA}/${riskId}/view?tab=2`
                    );
                } else {
                    setOpenConfirm(false);
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to save data'),
                    });
                }
            } catch (error) {
                console.log(error);
                setOpenConfirm(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to save data'),
                });
            }
        } else {
            const riskMapTopic = [];
            //// Master /////
            for (const item in riskMapMaster) {
                let riskLevel = [];
                if (valueSave.riskMap) {
                    if (
                        valueSave.riskMap.includes(
                            riskMapMaster[item].mRiskMapTopicId
                        )
                    ) {
                        for (const i in riskMapMaster[item].riskMapLevels) {
                            riskLevel.push({
                                riskMapLevelId:
                                    findRiskMapLevelId(
                                        detail.riskMap,
                                        riskMapMaster[item].riskMapLevels[i]
                                            .mRiskMapLevelId
                                    )?.itemRisk[i]?.riskMapLevelId || null, //get id
                                riskMapLevelName:
                                    valueSave[
                                        riskMapMaster[item].riskMapLevels[i]
                                            .mRiskMapLevelId
                                    ].riskMapLevelName,
                                mRiskMapLevelId:
                                    riskMapMaster[item].riskMapLevels[i]
                                        .mRiskMapLevelId,
                            });
                        }
                        riskMapTopic.push({
                            riskMapTopicId:
                                findRiskMapTopicId(
                                    detail.riskMap,
                                    riskMapMaster[item].mRiskMapTopicId
                                )?.id || null, //get id
                            mRiskMapTopicId:
                                riskMapMaster[item].mRiskMapTopicId,
                            riskMapLevel: riskLevel,
                        });
                    }
                }
            }
            const riskMapTopicAddOn = [];
            if (valueSave.riskMapTopicAddOn) {
                // console.log(valueSave.riskMapTopicAddOn)
                for (const item in valueSave.riskMapTopicAddOn) {
                    let riskMapLevelAddOnName = [];
                    if (valueSave.riskMapTopicAddOn[item].riskMapLevelAddOn1) {
                        riskMapLevelAddOnName.push({
                            riskMapLevelAddOnId:
                                valueSave.riskMapTopicAddOn[item]
                                    .riskMapLevelAddOn1.riskMapLevelAddOnId ||
                                null,
                            riskMapLevelAddOnName:
                                valueSave.riskMapTopicAddOn[item]
                                    .riskMapLevelAddOn1.riskMapLevelAddOnName,
                            seq: '',
                        });
                    }
                    if (valueSave.riskMapTopicAddOn[item].riskMapLevelAddOn2) {
                        riskMapLevelAddOnName.push({
                            riskMapLevelAddOnId:
                                valueSave.riskMapTopicAddOn[item]
                                    .riskMapLevelAddOn2.riskMapLevelAddOnId ||
                                null,
                            riskMapLevelAddOnName:
                                valueSave.riskMapTopicAddOn[item]
                                    .riskMapLevelAddOn2.riskMapLevelAddOnName,
                            seq: '',
                        });
                    }
                    if (valueSave.riskMapTopicAddOn[item].riskMapLevelAddOn3) {
                        riskMapLevelAddOnName.push({
                            riskMapLevelAddOnId:
                                valueSave.riskMapTopicAddOn[item]
                                    .riskMapLevelAddOn3.riskMapLevelAddOnId ||
                                null,
                            riskMapLevelAddOnName:
                                valueSave.riskMapTopicAddOn[item]
                                    .riskMapLevelAddOn3.riskMapLevelAddOnName,
                            seq: '',
                        });
                    }
                    if (valueSave.riskMapTopicAddOn[item].riskMapLevelAddOn4) {
                        riskMapLevelAddOnName.push({
                            riskMapLevelAddOnId:
                                valueSave.riskMapTopicAddOn[item]
                                    .riskMapLevelAddOn4.riskMapLevelAddOnId ||
                                null,
                            riskMapLevelAddOnName:
                                valueSave.riskMapTopicAddOn[item]
                                    .riskMapLevelAddOn4.riskMapLevelAddOnName,
                            seq: '',
                        });
                    }
                    if (valueSave.riskMapTopicAddOn[item].riskMapLevelAddOn5) {
                        riskMapLevelAddOnName.push({
                            riskMapLevelAddOnId:
                                valueSave.riskMapTopicAddOn[item]
                                    .riskMapLevelAddOn5.riskMapLevelAddOnId ||
                                null,
                            riskMapLevelAddOnName:
                                valueSave.riskMapTopicAddOn[item]
                                    .riskMapLevelAddOn5.riskMapLevelAddOnName,
                            seq: '',
                        });
                    }

                    const newRiskMapLevelAddOnName = riskMapLevelAddOnName.map(
                        (obj) =>
                            obj
                                ? {
                                      ...obj,
                                      seq:
                                          Number(
                                              riskMapLevelAddOnName.indexOf(obj)
                                          ) + 1,
                                  }
                                : obj
                    );
                    riskMapTopicAddOn.push({
                        riskMapTopicAddOnId:
                            valueSave.riskMapTopicAddOn[item].id || null, //get id
                        riskMapTopicAddOnName:
                            valueSave.riskMapTopicAddOn[item]
                                .riskMapTopicAddOnName,
                        seq: Number(item) + 1,
                        riskMapLevelAddOn: newRiskMapLevelAddOnName,
                    });
                }
            }
            try {
                const { data } = await RiskAssessmentService.updateRiskMap({
                    riskMapTopic: riskMapTopic ? riskMapTopic : [],
                    riskMapTopicAddOn: riskMapTopicAddOn
                        ? riskMapTopicAddOn
                        : [],
                });
                if (data?.resultCode === 1) {
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully save data'),
                    });
                    setOpenChange(false);
                    setChange(false);
                    setLoading(false);
                    setOpenConfirm(false);
                    Navigate(
                        `${ROUTER.RISK_MANAGEMENT.RA}/${riskId}/view?tab=2`
                    );
                } else {
                    setOpenConfirm(false);
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to save data'),
                    });
                }
            } catch (error) {
                console.log(error);
                setOpenConfirm(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to save data'),
                });
            }
        }
    };

    const findRiskMapLevelId = (array, mRiskMapLevelId) => {
        return array.find((element) => {
            return element.itemRisk?.find((item) => {
                return item.mRiskMapLevelId === mRiskMapLevelId;
            });
        });
    };
    const findRiskMapTopicId = (array, mRiskMapTopicId) => {
        return array.find((element) => {
            return element.mRiskMapTopicId === mRiskMapTopicId;
        });
    };

    const getRiskMapEx = async () => {
        setLoadingForm(true);
        const { data } = await RiskAssessmentService.getRiskMap();
        if (data.resultData) {
            const items = data.resultData.riskMapTopics;

            items?.forEach((element) => {
                setCheckExData((prevState) => {
                    const newState = prevState.map((obj) => {
                        if (obj.nameValue === element.mRiskMapTopicId) {
                            return { ...obj, checked: false };
                        }
                        return obj;
                    });
                    return newState;
                });
            });
            await setRiskMapMaster(data.resultData.riskMapTopics);
            await items?.forEach((element) => {
                element.riskMapLevels?.forEach((i) => {
                    setFields([
                        {
                            name: [`${i.mRiskMapLevelId}`],
                            value: { riskMapLevelName: i.mRiskMapLevelName },
                        },
                    ]);
                });
            });
        }
    };
    useEffect(() => {
        setLoadingForm(true);
        const getDefinitions = async () => {
            const { data } = await RiskAssessmentService.getDefinitions();
            if (data.resultData) {
                setDefinitionsMaster(data.resultData);
            }
        };
        const getRiskMap = async () => {
            const { data } = await RiskAssessmentService.getRiskMap();
            if (data.resultData) {
                const items = data.resultData.riskMapTopics;
                items?.forEach((element) => {
                    setCheckExData((checkExData) => [
                        ...checkExData,
                        {
                            nameValue: element.mRiskMapTopicId,
                            checked: false,
                        },
                    ]);
                });
                await setRiskMapMaster(data.resultData.riskMapTopics);
                await items?.forEach((element) => {
                    element.riskMapLevels?.forEach((i) => {
                        setFields([
                            {
                                name: [`${i.mRiskMapLevelId}`],
                                value: {
                                    riskMapLevelName: i.mRiskMapLevelName,
                                },
                            },
                        ]);
                    });
                });
                await setFieldsDetail();
            }
        };
        getDefinitions();
        getRiskMap();
    }, [detail]);

    const setFieldsDetail = async () => {
        if (detail) {
            let riskMap = [];
            detail.riskMap?.forEach((element) => {
                // console.log(element)
                riskMap.push(element.mRiskMapTopicId);
                setCheckExData((prevState) => {
                    const newState = prevState.map((obj) => {
                        if (obj.nameValue === element.mRiskMapTopicId) {
                            return { ...obj, checked: true };
                        }
                        return obj;
                    });
                    return newState;
                });

                if (element.itemRisk.length) {
                    element.itemRisk?.forEach((item) => {
                        setFields([
                            {
                                name: `${item.mRiskMapLevelId}`,
                                value: item,
                            },
                        ]);
                    });
                }
            });
            setFields([
                {
                    name: 'riskMap',
                    value: riskMap,
                },
            ]);
            let riskMapAddOn = [];
            detail.riskMapAddOn?.forEach((element) => {
                if (element.itemRisk.length) {
                    riskMapAddOn.push({
                        id: element.id,
                        riskMapTopicAddOnId: element.riskMapTopicAddOnId,
                        riskMapTopicAddOnName: element.riskMapTopicAddOnName,
                        seq: element.riskMapTopicAddOnName,
                        riskMapLevelAddOn1: element.itemRisk[0],
                        riskMapLevelAddOn2: element.itemRisk[1],
                        riskMapLevelAddOn3: element.itemRisk[2],
                        riskMapLevelAddOn4: element.itemRisk[3],
                        riskMapLevelAddOn5: element.itemRisk[4],
                    });
                }
            });
            setFields([
                {
                    name: 'riskMapTopicAddOn',
                    value: riskMapAddOn,
                },
            ]);
            setStatusForm(false);
            setLoadingForm(false);
        }
        // setLoadingForm(false);
    };
    return (
        <>
            <Spin spinning={loadingForm}>
                <Form
                    scrollToFirstError={{
                        behavior: 'smooth',
                        block: 'center',
                    }}
                    layout="vertical"
                    form={form}
                    fields={fields}
                    onFinish={(value) => {
                        setOpenConfirm(true);
                        setValueSave(value);
                    }}
                    onFinishFailed={(value) => {
                        console.log('value failed ', value);
                    }}
                    onFieldsChange={(_, allFields) => {
                        if (allFields.length > 0) {
                            setChange(true);
                        }
                    }}
                    onValuesChange={(_, allValues) => {
                        const keyValue = Object.values(allValues);
                        let iHave = 0;
                        let iNo = 0;
                        // console.log(keyValue)
                        keyValue?.forEach((i) => {
                            if (i && !i.riskMapLevelName) {
                                iHave = iHave + 1;
                                if (allValues.riskMapTopicAddOn.length) {
                                    const keyItemAddOn = Object.values(
                                        allValues.riskMapTopicAddOn
                                    );
                                    if (!keyItemAddOn[0]) {
                                        iHave = iHave - 1;
                                    } else {
                                        if (
                                            !keyItemAddOn[0].riskMapLevelAddOn1
                                                .riskMapLevelAddOnName &&
                                            !keyItemAddOn[0].riskMapLevelAddOn2
                                                .riskMapLevelAddOnName &&
                                            !keyItemAddOn[0].riskMapLevelAddOn3
                                                .riskMapLevelAddOnName &&
                                            !keyItemAddOn[0].riskMapLevelAddOn4
                                                .riskMapLevelAddOnName &&
                                            !keyItemAddOn[0].riskMapLevelAddOn5
                                                .riskMapLevelAddOnName
                                        ) {
                                            iHave = iHave - 1;
                                        }
                                    }
                                }
                                if (i?.length <= 0) {
                                    iNo = iNo + 1;
                                }
                            }
                        });

                        if (iHave - iNo > 0) {
                            // console.log('have data')
                            setStatusForm(false);
                            form.setFields([
                                {
                                    name: 'allData',
                                    errors: [''],
                                },
                            ]);
                        } else {
                            // console.log('no data')
                            setStatusForm(true);
                        }
                    }}
                    // initialValues={{ }}
                >
                    <div className="p-4">
                        <div
                            className="mb-4"
                            style={{ borderBottom: '3px solid #F4F6FC' }}
                        >
                            <div className="flex justify-between">
                                <div className="flex space-x-2 items-center pb-2">
                                    <div className="text-2xl font-bold pb-1">
                                        {t('RA.RiskMap')}
                                    </div>
                                    <Tooltip
                                        overlayStyle={{
                                            minWidth: '18%',
                                        }}
                                        placement="rightTop"
                                        title={t('Tooltip.RiskMap')}
                                    >
                                        <a className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm">
                                            <ExclamationCircleOutlined />
                                        </a>
                                    </Tooltip>
                                </div>
                                <div>
                                    <div className="flex space-x-4 items-center">
                                        <Button
                                            size="large"
                                            type="default"
                                            className="text-purple-PHX border-purple-PHX w-32"
                                            onClick={changePage}
                                        >
                                            {t('common.Cancel')}
                                        </Button>
                                        <Button
                                            size="large"
                                            type="primary"
                                            className="w-32"
                                            htmlType="submit"
                                        >
                                            {t('common.Save')}
                                        </Button>
                                    </div>
                                </div>
                            </div>

                            <div className="pb-6 flex items-center">
                                <div className="font-bold">
                                    {t('Last Update')} :{' '}
                                </div>
                                <div className="ml-1">
                                    {lastUpdate?.riskMapUpdateDate || '-'}
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-3">
                            <div className="col-span-2 p-2 mb-2 table-risk-custom">
                                <table
                                    style={{
                                        width: '100%',
                                    }}
                                >
                                    <thead>
                                        <tr>
                                            <th colSpan={2}>
                                                {t('RA.Definition')}
                                            </th>
                                            <th>{t('RA.Guidelines')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {definitionsMaster?.map((e) => (
                                            <tr key={e.levelId}>
                                                <td
                                                    style={{
                                                        background: `${
                                                            getLevelColor(
                                                                e.levelId
                                                            ).background
                                                        }`,
                                                        color: `${
                                                            getLevelColor(
                                                                e.levelId
                                                            ).color
                                                        }`,
                                                        fontWeight: '600',
                                                        textAlign: 'center',
                                                        border: 'none',
                                                    }}
                                                >
                                                    {lang === 'en'
                                                        ? e.levelEn
                                                        : e.levelTh}
                                                </td>
                                                <td>
                                                    {lang === 'en'
                                                        ? e.levelNameEn
                                                        : e.levelNameTh}
                                                </td>
                                                <td>
                                                    {lang === 'en'
                                                        ? e.descriptionEn
                                                        : e.descriptionTh}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <Form.Item className="mt-4" name={'riskMap'}>
                            <Checkbox.Group className="w-full mb-1">
                                {riskMapMaster?.map((is, index) => (
                                    <div key={is.mRiskMapTopicId}>
                                        <Checkbox
                                            key={is.mRiskMapTopicId}
                                            value={is.mRiskMapTopicId}
                                            style={{
                                                lineHeight: '32px',
                                            }}
                                            onChange={(e) => {
                                                setCheckExData((prevState) => {
                                                    const newState =
                                                        prevState.map((obj) => {
                                                            if (
                                                                obj.nameValue ===
                                                                e.target.value
                                                            ) {
                                                                return {
                                                                    ...obj,
                                                                    checked:
                                                                        e.target
                                                                            .checked,
                                                                };
                                                            }
                                                            return obj;
                                                        });
                                                    return newState;
                                                });
                                            }}
                                        >
                                            <div className="grid grid-cols-3 mb-5">
                                                <div className="col-span-2 p-4 box-content">
                                                    <div className="text-base font-semibold mb-4">
                                                        {lang === 'en'
                                                            ? is.mRiskMapTopicNameEn
                                                            : is.mRiskMapTopicNameTh}
                                                    </div>
                                                    {is.riskMapLevels?.map(
                                                        (item) => (
                                                            <div
                                                                key={
                                                                    item.mRiskMapLevelId
                                                                }
                                                                className="pl-5 relative mb-3"
                                                            >
                                                                <Form.Item
                                                                    className="mb-0"
                                                                    name={[
                                                                        `${item.mRiskMapLevelId}`,
                                                                        'riskMapLevelName',
                                                                    ]}
                                                                    rules={[
                                                                        {
                                                                            required:
                                                                                checkExData?.find(
                                                                                    (
                                                                                        f
                                                                                    ) =>
                                                                                        f.nameValue ===
                                                                                        is.mRiskMapTopicId
                                                                                )
                                                                                    .checked,
                                                                            message:
                                                                                t(
                                                                                    'errorText.requiredField'
                                                                                ),
                                                                        },
                                                                    ]}
                                                                >
                                                                    <TextArea
                                                                        className="pr-12 bg-white"
                                                                        style={{
                                                                            width: '850px',
                                                                        }}
                                                                        autoSize={{
                                                                            minRows: 2,
                                                                            maxRows: 2,
                                                                        }}
                                                                        placeholder={t(
                                                                            'dataFlow.inputpl'
                                                                        )}
                                                                        disabled={
                                                                            checkExData?.find(
                                                                                (
                                                                                    f
                                                                                ) =>
                                                                                    f.nameValue ===
                                                                                    is.mRiskMapTopicId
                                                                            )
                                                                                .checked ===
                                                                            false
                                                                        }
                                                                    />
                                                                </Form.Item>
                                                                <div
                                                                    className={`absolute px-0 py-2 absolute top-0 left-0 text-[${
                                                                        getLevelColor(
                                                                            item.mRiskLevelPlanId
                                                                        )
                                                                            .background
                                                                    }] text-4xl align-middle`}
                                                                >
                                                                    &#8226;
                                                                </div>
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            </div>
                                        </Checkbox>
                                    </div>
                                ))}
                            </Checkbox.Group>
                        </Form.Item>

                        {/* riskMapTopicAddOn */}
                        <Form.List name="riskMapTopicAddOn">
                            {(fields, { add, remove }) => (
                                <>
                                    {fields.map(
                                        ({ key, name, ...restField }, i) => (
                                            <div key={key} className="flex">
                                                <Form.Item
                                                    style={{
                                                        marginTop: '-1.75rem',
                                                    }}
                                                    className="w-full"
                                                    {...restField}
                                                    name={[
                                                        name,
                                                        'riskMapTopicAddOnCheckbox',
                                                    ]}
                                                    valuePropName="checked"
                                                >
                                                    <Checkbox
                                                        key={`addOnCheckbox${key}`}
                                                        value={`addOnCheckbox${key}`}
                                                        style={{
                                                            lineHeight: '32px',
                                                        }}
                                                        checked={true}
                                                        // defaultChecked
                                                    >
                                                        <div
                                                            className="grid grid-cols-3"
                                                            key={key}
                                                        >
                                                            <div className="col-span-2 p-4 mb-6 box-content relative">
                                                                <div className="text-base mb-1">
                                                                    <Form.Item
                                                                        className="mb-4 w-full"
                                                                        {...restField}
                                                                        label={
                                                                            <span className="text-base font-semibold">
                                                                                {t(
                                                                                    'RA.TopicRiskMap'
                                                                                )}
                                                                            </span>
                                                                        }
                                                                        // name={[name, 'riskMapTopicAddOnName']}
                                                                        name={[
                                                                            name,
                                                                            'riskMapTopicAddOnName',
                                                                        ]}
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message:
                                                                                    t(
                                                                                        'errorText.requiredField'
                                                                                    ),
                                                                            },
                                                                        ]}
                                                                    >
                                                                        <Input
                                                                            placeholder={t(
                                                                                'RA.TopicInputpl'
                                                                            )}
                                                                            size="large"
                                                                            className="pr-12 bg-white"
                                                                        />
                                                                    </Form.Item>
                                                                    <div className="text-sm mb-1">
                                                                        {/* Level 1 */}
                                                                        <div className="pl-5 relative mb-2">
                                                                            <Form.Item
                                                                                name={[
                                                                                    name,
                                                                                    [
                                                                                        `riskMapLevelAddOn1`,
                                                                                    ],
                                                                                    `riskMapLevelAddOnName`,
                                                                                ]}
                                                                                rules={[
                                                                                    {
                                                                                        required: true,
                                                                                        message:
                                                                                            t(
                                                                                                'errorText.requiredField'
                                                                                            ),
                                                                                    },
                                                                                ]}
                                                                            >
                                                                                <TextArea
                                                                                    className="pr-12 bg-white"
                                                                                    style={{
                                                                                        width: '850px',
                                                                                    }}
                                                                                    autoSize={{
                                                                                        minRows: 2,
                                                                                        maxRows: 2,
                                                                                    }}
                                                                                    placeholder={t(
                                                                                        'RA.RiskLevelpl'
                                                                                    )}
                                                                                />
                                                                            </Form.Item>
                                                                            <div className="absolute px-0 py-2 absolute top-0 left-0 text-[#A7D17E] text-4xl align-middle">
                                                                                &#8226;
                                                                            </div>{' '}
                                                                        </div>
                                                                        {/* Level 2 */}
                                                                        <div className="pl-5 relative mb-2">
                                                                            <Form.Item
                                                                                // name={[ name,'riskMapItem2']}
                                                                                name={[
                                                                                    name,
                                                                                    [
                                                                                        `riskMapLevelAddOn2`,
                                                                                    ],
                                                                                    'riskMapLevelAddOnName',
                                                                                ]}
                                                                                rules={[
                                                                                    {
                                                                                        required: true,
                                                                                        message:
                                                                                            t(
                                                                                                'errorText.requiredField'
                                                                                            ),
                                                                                    },
                                                                                ]}
                                                                            >
                                                                                <TextArea
                                                                                    className="pr-12 bg-white"
                                                                                    style={{
                                                                                        width: '850px',
                                                                                    }}
                                                                                    autoSize={{
                                                                                        minRows: 2,
                                                                                        maxRows: 2,
                                                                                    }}
                                                                                    placeholder={t(
                                                                                        'RA.RiskLevelpl'
                                                                                    )}
                                                                                />
                                                                            </Form.Item>
                                                                            <div className="absolute px-0 py-2 absolute top-0 left-0 text-[#FFD15C] text-4xl align-middle">
                                                                                &#8226;
                                                                            </div>{' '}
                                                                        </div>
                                                                        {/* Level 3 */}
                                                                        <div className="pl-5 relative mb-2">
                                                                            <Form.Item
                                                                                // name={[ name,'riskMapItem3']}
                                                                                name={[
                                                                                    name,
                                                                                    [
                                                                                        `riskMapLevelAddOn3`,
                                                                                    ],
                                                                                    'riskMapLevelAddOnName',
                                                                                ]}
                                                                                rules={[
                                                                                    {
                                                                                        required: true,
                                                                                        message:
                                                                                            t(
                                                                                                'errorText.requiredField'
                                                                                            ),
                                                                                    },
                                                                                ]}
                                                                            >
                                                                                <TextArea
                                                                                    className="pr-12 bg-white"
                                                                                    style={{
                                                                                        width: '850px',
                                                                                    }}
                                                                                    autoSize={{
                                                                                        minRows: 2,
                                                                                        maxRows: 2,
                                                                                    }}
                                                                                    placeholder={t(
                                                                                        'RA.RiskLevelpl'
                                                                                    )}
                                                                                />
                                                                            </Form.Item>
                                                                            <div className="absolute px-0 py-2 absolute top-0 left-0 text-[#EA8A54] text-4xl align-middle">
                                                                                &#8226;
                                                                            </div>{' '}
                                                                        </div>
                                                                        {/* Level 4 */}
                                                                        <div className="pl-5 relative mb-2">
                                                                            <Form.Item
                                                                                // name={[ name,'riskMapItem4']}
                                                                                name={[
                                                                                    name,
                                                                                    [
                                                                                        `riskMapLevelAddOn4`,
                                                                                    ],
                                                                                    'riskMapLevelAddOnName',
                                                                                ]}
                                                                                rules={[
                                                                                    {
                                                                                        required: true,
                                                                                        message:
                                                                                            t(
                                                                                                'errorText.requiredField'
                                                                                            ),
                                                                                    },
                                                                                ]}
                                                                            >
                                                                                <TextArea
                                                                                    className="pr-12 bg-white"
                                                                                    style={{
                                                                                        width: '850px',
                                                                                    }}
                                                                                    autoSize={{
                                                                                        minRows: 2,
                                                                                        maxRows: 2,
                                                                                    }}
                                                                                    placeholder={t(
                                                                                        'RA.RiskLevelpl'
                                                                                    )}
                                                                                />
                                                                            </Form.Item>
                                                                            <div className="absolute px-0 py-2 absolute top-0 left-0 text-[#CD5D4A] text-4xl align-middle">
                                                                                &#8226;
                                                                            </div>{' '}
                                                                        </div>
                                                                        {/* Level 5 */}
                                                                        <div className="pl-5 relative mb-2">
                                                                            <Form.Item
                                                                                // name={[ name,'riskMapItem5']}
                                                                                name={[
                                                                                    name,
                                                                                    [
                                                                                        `riskMapLevelAddOn5`,
                                                                                    ],
                                                                                    'riskMapLevelAddOnName',
                                                                                ]}
                                                                                rules={[
                                                                                    {
                                                                                        required: true,
                                                                                        message:
                                                                                            t(
                                                                                                'errorText.requiredField'
                                                                                            ),
                                                                                    },
                                                                                ]}
                                                                            >
                                                                                <TextArea
                                                                                    className="pr-12 bg-white"
                                                                                    style={{
                                                                                        width: '850px',
                                                                                    }}
                                                                                    autoSize={{
                                                                                        minRows: 2,
                                                                                        maxRows: 2,
                                                                                    }}
                                                                                    placeholder={t(
                                                                                        'RA.RiskLevelpl'
                                                                                    )}
                                                                                />
                                                                            </Form.Item>
                                                                            <div className="absolute px-0 py-2 absolute top-0 left-0 text-[#A3402F] text-4xl align-middle">
                                                                                &#8226;
                                                                            </div>{' '}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    className="cursor-pointer hover:opacity-80 absolute top-0 right-2 p-3"
                                                                    onClick={() => {
                                                                        setOpenConfirmDelete(
                                                                            true
                                                                        );
                                                                        setNameDelete(
                                                                            name
                                                                        );
                                                                    }}
                                                                >
                                                                    {
                                                                        DeleteIcon2
                                                                    }
                                                                </button>
                                                                <ModalDelete
                                                                    title={t(
                                                                        'common.ConfirmDelete'
                                                                    )}
                                                                    text={t(
                                                                        'RA.modalDelete'
                                                                    )}
                                                                    open={
                                                                        openConfirmDelete
                                                                    }
                                                                    handelOk={() => {
                                                                        remove(
                                                                            nameDelete
                                                                        );
                                                                        setOpenConfirmDelete(
                                                                            false
                                                                        );
                                                                        setNameDelete(
                                                                            ''
                                                                        );
                                                                        notify({
                                                                            title: t(
                                                                                'common.Success'
                                                                            ),
                                                                            description:
                                                                                t(
                                                                                    'Successfully to submitted'
                                                                                ),
                                                                        });
                                                                    }}
                                                                    handelClose={() =>
                                                                        setOpenConfirmDelete(
                                                                            false
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    </Checkbox>
                                                    <br />
                                                </Form.Item>
                                            </div>
                                        )
                                    )}
                                    <Form.Item
                                        className="mb-0"
                                        style={{ marginTop: '-2%' }}
                                    >
                                        <button
                                            type="button"
                                            className="text-blue-400 hover:opacity-80 cursor-pointer font-semibold"
                                            onClick={() => add()}
                                        >
                                            <PlusCircleOutlined />{' '}
                                            {t('RA.AddRiskMap')}
                                        </button>
                                    </Form.Item>
                                </>
                            )}
                        </Form.List>

                        <Form.Item
                            style={{ marginTop: '-0.65%', display: 'block' }}
                            name={'allData'}
                            rules={[
                                {
                                    required: statusForm,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        ></Form.Item>
                    </div>
                </Form>
            </Spin>
            <BackTop>
                <div style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
            <ModalConfirm
                loading={loading}
                text={t('Do you want to confirm')}
                open={openConfirm}
                handelOk={onSubmit}
                handelClose={() => setOpenConfirm(false)}
            />
        </>
    );
}
const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};
const DeleteIcon2 = (
    <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width="32" height="32" rx="6" fill="#EEE5FF" />
        <path
            d="M15.9998 9C16.5487 8.99992 17.0778 9.20504 17.4832 9.57509C17.8887 9.94513 18.1411 10.4534 18.191 11H21.5998C21.7518 11 21.8982 11.0578 22.0092 11.1616C22.1203 11.2654 22.1879 11.4074 22.1982 11.5591C22.2086 11.7108 22.161 11.8607 22.0651 11.9786C21.9691 12.0966 21.832 12.1737 21.6814 12.1944L21.5998 12.2H21.1334L20.1198 20.984C20.0747 21.3739 19.8878 21.7336 19.5947 21.9947C19.3016 22.2558 18.9227 22.4001 18.5302 22.4H13.4694C13.0769 22.4001 12.698 22.2558 12.4049 21.9947C12.1118 21.7336 11.9249 21.3739 11.8798 20.984L10.8654 12.2H10.3998C10.2548 12.2 10.1147 12.1475 10.0055 12.0522C9.89619 11.9569 9.82512 11.8252 9.8054 11.6816L9.7998 11.6C9.79981 11.455 9.85232 11.3149 9.94762 11.2057C10.0429 11.0964 10.1746 11.0253 10.3182 11.0056L10.3998 11H13.8086C13.8585 10.4534 14.1109 9.94513 14.5164 9.57509C14.9218 9.20504 15.4509 8.99992 15.9998 9ZM14.7998 14C14.6038 14 14.4398 14.124 14.4062 14.2872L14.3998 14.3504V19.2504L14.4062 19.3128C14.4398 19.476 14.6038 19.6 14.7998 19.6C14.9958 19.6 15.1598 19.476 15.1934 19.3128L15.1998 19.2496V14.3512L15.1934 14.2872C15.1598 14.1248 14.9958 14 14.7998 14ZM17.1998 14C17.0038 14 16.8398 14.124 16.8062 14.2872L16.7998 14.3504V19.2504L16.8062 19.3128C16.8398 19.476 17.0038 19.6 17.1998 19.6C17.3958 19.6 17.5598 19.476 17.5934 19.3128L17.5998 19.2496V14.3512L17.5934 14.2872C17.5598 14.1248 17.3958 14 17.1998 14ZM15.9998 10.2C15.5158 10.2 15.1118 10.544 15.0198 11H16.9798C16.887 10.544 16.4838 10.2 15.9998 10.2Z"
            fill="#7B67FB"
        />
    </svg>
);
